/** Name of the hidden field carrying the form's Sanity "Form ID" on submit;
 *  the send-form route reads it to resolve the form title. */
export const FORM_ID_FIELD = '_formId';

/** Name of the hidden field carrying which way into the conversation was taken
 *  ("Rückruf oder E-Mail" / "Ich habe schon eine konkrete Projekt-Idee"). Unlike
 *  the other hidden fields this one is content, but it belongs in the subject
 *  rather than the body: it is the one thing worth seeing in an inbox list, and
 *  repeating it as a row would say the same thing twice. Written by
 *  features/contact-module, promoted to the subject by the send-form route. */
export const SUBJECT_FIELD = 'Weg';

/** Name of the hidden field carrying which contact way was used, as a stable
 *  key. SUBJECT_FIELD carries the editorial title, which editors may rename;
 *  the route needs something that does not change to pick the right
 *  recipients and ClickUp list. Absent on the generic form block. */
export const WAY_FIELD = '_way';

/** The two ways of the contact module; keys of the per-way delivery settings. */
export type ContactWay = 'callback' | 'quiz';

export function isContactWay(value: unknown): value is ContactWay {
    return value === 'callback' || value === 'quiz';
}

export type FormDto = {
    id: string;
    title?: string;
    fields?: FormFieldDto[];
    submitButton?: {
        text?: string;
    };
};

export type FormFieldDto = {
    _key?: string;
    label?: string;
    name?: string;
    required?: boolean;
    type?:
        | 'checkbox'
        | 'color'
        | 'date'
        | 'datetime-local'
        | 'email'
        | 'file'
        | 'hidden'
        | 'number'
        | 'radio'
        | 'range'
        | 'select'
        | 'tel'
        | 'text'
        | 'textarea'
        | 'time'
        | 'url';
    validation?: {
        type?: string;
        value?: string;
        message?: string;
    }[];
    choices?: {
        label?: string;
        value?: string;
    }[];
    options?: {
        placeholder?: string;
        defaultValue?: string;
    };
};
